import { useEffect, useState } from "react";
import "./SubtitleRenderer.css";

const SubtitleRenderer = ({
    text = "",
    isAbsolute = false,
    isActive = true,
    textApparitionSpeed = 70,
}) => {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        let index = 0;

        let cacheText = "";
        const timeout = setInterval(() => {
            setDisplayedText(() => {
                cacheText += text.charAt(index);
                index++;
                return cacheText;
            });
            if (index >= text.length) {
                clearInterval(timeout);
            }
        }, textApparitionSpeed);

        return () => clearInterval(timeout);
    }, [text, textApparitionSpeed]);

    if (!isActive) return null;
    return (
        <div className={`subtitle-container${isAbsolute ? " subtitle-absolute" : ""}`} style={{ minHeight: "47px"}}>
            {text &&
            <span className="subtitle-text">
                {displayedText}
            </span>}
        </div>
    );
};

export default SubtitleRenderer;